import React from 'react';
import { Link } from 'react-router-dom';

import IconWinkyReader from './icon-winky-reader.svg';
import IconBalloon from './icon-balloon.svg';
import IconLock from './icon-lock.svg';

const TeachersLanding = () => (
  <div className="GenericText__content">
    <h2>Welcome to the new Funbrain!</h2>

    <p>
      Funbrain, created for kids in grades Pre-K through 8, offers hundreds of
      free interactive games, books, videos, and printables that help kids
      develop skills in math, reading, problem-solving, and literacy.
    </p>

    <p>
      Our new site makes it easier than ever to find what you’re looking for.
      We’ve created a unique landing page for each grade, Pre-K through 8, so
      kids can find the content that’s right for them. Each game, book, and
      video is tagged with key subject areas and skills, such as Addition,
      Fractions, Vowel Sounds, and Shapes.{' '}
    </p>

    <p>
      Educators and parents can feel confident that children will enjoy a fun
      and safe experience both at school and at home.
    </p>

    <ul className="GenericText__content-grid">
      <li className="GenericText__content-item">
        <IconBalloon />
        <p>Fun</p>
      </li>
      <li className="GenericText__content-item">
        <IconLock />
        <p>Safe</p>
      </li>
      <li className="GenericText__content-item">
        <IconWinkyReader />
        <p>Educational</p>
      </li>
    </ul>

    <p>
      Funbrain does not collect personally identifiable information from kids.
      For additional information, please see our{' '}
      <Link to="/privacy-policy">Privacy Policy</Link>.
    </p>
  </div>
);

export default TeachersLanding;
